import { Link, useParams } from 'react-router';

import { fetchQuotationDetail } from '#/api/crmMgmt/quotation/fetchDetail';
import { updateQuotation } from '#/api/crmMgmt/quotation/update';
import { ROUTES } from '#/config/routes';
import useDocumentRemarkSave from '#/hooks/useDocumentRemarkSave';
import { Button } from '#/modules/commonComponents/button';
import QuotationMainInfoCard from '#/modules/crmMgmt/quotation/components/QuotationMainInfoCard';
import {
  getQuotationApiErrorMessage,
  isQuotationVersionConflict,
} from '#/modules/crmMgmt/quotation/helper/apiError';
import DocumentRemarkEditForm from '#/modules/imsMgmt/receipts/shared/DocumentRemarkEditForm';
import PageShell from '#/modules/infra/layout/PageShell';
import {
  quotationDetailQueryKey,
  quotationListQueryKeyPrefix,
} from '#/utils/queryKeys';

/** 已發出／過期報價的表頭內部備註：PATCH 只送 `remark`＋`updatedAt`（後端只接受內部備註）。 */
const QuotationRemarkPage = () => {
  const { id } = useParams();

  const {
    detail,
    detailQuery,
    isPending,
    saveRemark,
  } = useDocumentRemarkSave({
    id,
    fetchDetail: fetchQuotationDetail,
    updateRemark: updateQuotation,
    detailQueryKey: quotationDetailQueryKey,
    listQueryKeyPrefix: quotationListQueryKeyPrefix,
    getErrorMessage: (error) => getQuotationApiErrorMessage(error, '更新備註失敗'),
    isVersionConflict: isQuotationVersionConflict,
    afterSaveNavigateTo: ROUTES.quotationDetail(id),
  });

  return (
    <PageShell variant="form">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div className="create_edit_page__header">
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">編輯報價單內部備註</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.quotationDetail(id)}>返回詳情</Link>
            </Button>
          </div>

          {detailQuery.isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {detailQuery.isError ? (
            <p className="text-sm text-destructive">
              {getQuotationApiErrorMessage(detailQuery.error, '找不到報價單')}
            </p>
          ) : null}

          {detail ? (
            <>
              <QuotationMainInfoCard detail={detail} compact />
              <DocumentRemarkEditForm
                initialRemark={detail.remark ?? ''}
                cancelTo={ROUTES.quotationDetail(id)}
                isPending={isPending}
                onSave={saveRemark}
              />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default QuotationRemarkPage;
